import React from 'react';

interface Props {
    children: React.ReactNode;
}

export function ItemDescription({ children }: Props) {
    return <p>{children}</p>;
}
